import React from 'react';
import { Html } from "@react-email/html";
import { Button } from "@react-email/button";
import { Text } from "@react-email/text";
import { Head } from "@react-email/head";
import { Container } from "@react-email/container";
import { render } from "@react-email/render";
import { Tailwind } from '@react-email/tailwind';

export default function MailTemplate({ name, email, subject, message }) {

    return (
        <Html lang="en" dir="ltr">       
        
            <Tailwind
                config={{
                    theme: {
                        extend: {
                            colors: {
                                brand: '#007291',
                            },
                        },
                    },
                }}
                >
                <Container>
                    <Head>Gossipment Contact Form</Head>
                    <Text>Name: {name}</Text>
                    <Text>Email: {email}</Text>
                    <Text>Subject: {subject}</Text>
                    <Text>Message: {message}</Text>
                    <Button
                    href="https://gossipment.com"
                    className="bg-brand px-3 py-2 font-medium leading-4 text-white"
                    >
                    View Website
                    </Button>
                </Container>
                
            </Tailwind>
        </Html>
    )
}
